<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <template v-if="params.data.user">
      <template v-if="params.data.user.active == true">
        <span
          style="display:inline-block;width:13px;height:13px;border-radius:50%;background-color:green;"
          title="Aktiv"
        ></span>
      </template>
      <template v-else>
        <span
          style="display:inline-block;width:13px;height:13px;border-radius:50%;background-color:red;"
          title="Inaktiv"
        ></span>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "CellRendererActive"
};
</script>
